import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Header } from "../..";
import SectionItem from "./SectionItem";
import { getRest } from "../../utils";

/**
 * Parent of multiple items.
 *
 * @param {*} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SectionGroup = function SectionGroup(props) {
  var children = props.children,
    content = props.content,
    compact = props.compact,
    items = props.items,
    title = props.title,
    titleRenderer = props.titleRenderer;
  var rest = getRest(SectionGroup, props);
  if (children) {
    return /*#__PURE__*/_jsxs(Grid, Object.assign({}, rest, {
      compact: compact,
      children: [!_.isNil(titleRenderer) ? titleRenderer() : title && /*#__PURE__*/_jsx(Grid.Row, {
        style: {
          paddingBottom: 0
        },
        children: /*#__PURE__*/_jsx(Header, {
          children: title
        })
      }), children]
    }));
  }
  if (content) {
    return /*#__PURE__*/_jsxs(Grid, Object.assign({}, rest, {
      compact: compact,
      children: [!_.isNil(titleRenderer) ? titleRenderer() : title && /*#__PURE__*/_jsx(Grid.Row, {
        style: {
          paddingBottom: 0
        },
        children: /*#__PURE__*/_jsx(Header, {
          children: title
        })
      }), content]
    }));
  }
  return /*#__PURE__*/_jsxs(Grid, Object.assign({}, rest, {
    children: [!_.isNil(titleRenderer) ? titleRenderer() : title && /*#__PURE__*/_jsx(Grid.Row, {
      style: {
        paddingBottom: 0
      },
      children: /*#__PURE__*/_jsx(Header, {
        children: title
      })
    }), _.map(items, function (item, index) {
      return /*#__PURE__*/React.createElement(SectionItem, Object.assign({
        compact: compact || index === 0
      }, item, {
        single: false
      }));
    })]
  }));
};
SectionGroup.handledProps = ["children", "compact", "content", "items", "title", "titleRenderer"];
SectionGroup.Item = SectionItem;

/** Proptypes. */
SectionGroup.propTypes = {
  /** */
  children: PropTypes.node,
  /** */
  content: PropTypes.node,
  /** A SectionGroup may have its items take up only as much space as is necessary. */
  compact: PropTypes.bool,
  /** Array of items */
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.array,
  /** Title. */
  title: PropTypes.string,
  /** Title renderer. */
  titleRenderer: PropTypes.func
};
export default SectionGroup;